import script from "./Chats.vue?vue&type=script&setup=true&lang=js"
export * from "./Chats.vue?vue&type=script&setup=true&lang=js"

import "./Chats.vue?vue&type=style&index=0&id=00f85718&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00f85718"]])

export default __exports__